import module from 'fan/proyecto/module.js'

module.config(($stateProvider) => {
    $stateProvider.state('proyecto.colaboradores', {
      abstract: true,
      url: '/colaboradores',
      template: '<fan-proyecto-colaboradores/>',
      data: {titleProxy: 'proyecto.colaboradores.lista'},
    })
  },
)



// WEBPACK FOOTER //
// ./src/fan/proyecto/routes/proyecto/colaboradores.js